import { client } from "utils";

export const getBrandsRequest = () => client.get("brands");

export const getBrandsByTenantCodeRequest = (code) => client.get(`brands?tenant_code=${code}`);
